<template>
    <div class="item-box">
        <div class="head-box" :style="{ backgroundColor: getOrderStatusColor(item)}">
            <div class="status">{{ getOrderStatus(item) }}</div>
            <div class="operating-btn">
                <elem-icon name="operating"></elem-icon>
                <comp-menu :absolute="true" position="follow" maxWidth="200px" :value="getMenu(item)" @select="onSelectMenu(item, $event)"></comp-menu>
            </div>
        </div>

        <div class="order-info contact-box">
            <div class="user-brief">
                <div class="avatar">
                    <img class="img" :src="getOrderUserAvatar(item)" @error="onUserAvatarError" />
                </div>
                <div class="meta">
                    <p class="username">{{ getOrderUserName(item) }}</p>
                    <p class="phone" :class="{ clickable: getOrderUserPhone(item) !== '-' }" @click="getOrderUserPhone(item) !== '-' && copyText(getOrderUserPhone(item))">
                        {{ getOrderUserPhone(item) }}
                    </p>
                </div>
            </div>
            <div class="item-box">
                <p class="name">订单类型:</p>
                <p class="value">{{ { 1: "快递配送", 2: "配送上门", 3: "到店自提", 4: "堂食", 5: "无需配送" }[item.pathway] || "未知" }}</p>
            </div>
            <div class="item-box" v-if="item.store">
                <p class="name">自提门店:</p>
                <p class="value">{{ item.store.storeName }}</p>
            </div>
            <div class="item-box">
                <p class="name">订单编号:</p>
                <p class="value">{{ item.orderNumber }}</p>
            </div>
            <div class="item-box">
                <p class="name">下单时间:</p>
                <p class="value">{{ item.createdDate }}</p>
            </div>
            <div class="item-box" v-if="item.expressNumber" @click="item.expressNumber && copyText(item.expressNumber)">
                <p class="name">发货单号:</p>
                <p class="value">{{ item.expressNumber }}</p>
            </div>
            <div class="item-box" v-if="item.address">
                <p class="name">联系人:</p>
                <p class="value">{{ [item.address.name, item.address.phone].join(" - ") }}</p>
            </div>
            <div class="item-box" v-if="item.address">
                <p class="name">地址:</p>
                <p class="value">{{ [item.address.province, item.address.city, item.address.district, item.address.address].join(" - ") }}</p>
            </div>
            <div class="item-box">
                <p class="name">备注:</p>
                <p class="value">{{ item.remark || "-" }}</p>
            </div>
        </div>

        <div class="order-info goods-box">
            <div class="item" v-for="(goods, idx) in item.goodsItems" :key="idx" :title="goods.title">
                <div class="img" :style="{ 'background-image': 'url(' + goods.cover.url + '?x-oss-process=image/resize,m_fill,h_300,w_300,limit_0' + ')' }"></div>
                <div class="info-box">
                    <div class="name">{{ goods.title }}</div>
                    <div class="spec">{{ goods.specification?.map(v => v.title).join(', ') }}</div>
                    <div class="quantity">x{{ goods.quantity }}</div>
                </div>
            </div>
        </div>

        <div class="order-info data-box">
            <div class="item-box">
                <p class="name">订单金额</p>
                <p class="value">￥{{ centsToYuan(item.price) }}</p>
            </div>
            <div class="item-box">
                <p class="name">运费</p>
                <p class="value">￥{{ centsToYuan(item.postagePrice) }}</p>
            </div>
            <div class="item-box">
                <p class="name">分销</p>
                <p class="value">{{ item.distribution ? item.distribution.name : "-" }}</p>
            </div>
        </div>

        <div class="order-info operate-box">
            <button class="item g" v-if="isTransportStatus(item, 'WAITING_ACCEPT')" @click="onAccepted(item)">接单</button>
            <button class="item b" v-else-if="isTransportStatus(item, 'PREPARING')" @click="onPrepared(item)">备货完成</button>
            <button class="item b" v-else-if="isTransportStatus(item, 'WAITING_SHIPMENTS') && item.orderType === 'VIRTUAL_GOODS'" @click="onVirtualDelivery(item)">发货</button>
            <button class="item b" v-else-if="isTransportStatus(item, 'WAITING_SHIPMENTS')" @click="onShipments(item)">发货</button>
            <button class="item b" v-else-if="isTransportStatus(item, 'WAITING_DELIVERED')" @click="onStartDelivery(item)">开始配送</button>
            <button class="item b" v-else-if="isTransportStatus(item, 'DELIVERING')" @click="onDelivered(item)">已送达</button>
            <!-- <button class="item r" v-if="item.paymentStatus === 1" @click="onAccepted(item)">退款</button> -->
        </div>
    </div>
</template>

<script lang="ts">
import Utils from '@/module/utils/utils'
import Message from "@/module/interactive/message"
import Request from '@/module/request/request';

export default {

    props: {
        item: {
            type: Object,
            required: true
        }
    },

    methods: {
        copyText: Utils.copyText,

        /**
         * 价格单位 分 转 元，保留两位小数
         * @param amount 金额，单位：分
         */
        centsToYuan(amount: number): string {
            if (!amount) {
                return "0.00"
            }

            return (amount / 100).toFixed(2)
        },

        getOrderStatus(item: obj) {
            if (!item) return ""
            let p = { 0: "未支付", 2: "已取消", 3: "支付失败" }[item.paymentStatus]
            if (p) return p
            return (
                { WAITING_ACCEPT: "待接单", WAITING_DELIVERED: "待配送", PREPARING: "备货中", WAITING_GET: "待取货", DELIVERING: "配送中", DELIVERED: "已送达", WAITING_CONFIRM: "待确认", WAITING_SHIPMENTS: "待发货", WAITING_RECEIPT: "待收货", WAITING_COMMENT: "待评价", SUCCESS: "已完成" }[item.transportStatus] || "已完成"
            )
        },

        getOrderStatusColor(item: obj) {
            if (item.paymentStatus !== 1) {
                return "#333"
            }

            return {
                WAITING_ACCEPT: "#007843",
                WAITING_SHIPMENTS: "#00acdb"
            }[item.transportStatus] || "#333"
        },

        getOrderUserAvatar(item: obj): string {
            const u = this.getOrderUser(item)
            return u?.avatar?.url || "static/icon/user.svg"
        },

        getOrderUser(item: obj): obj {
            if (!item) return null
            return item.user
        },

        getOrderUserName(item: obj): string {
            const u = this.getOrderUser(item)
            return u?.username || "匿名用户"
        },

        getOrderUserPhone(item: obj): string {
            const u = this.getOrderUser(item)
            return u?.phone || "-"
        },

        onUserAvatarError(evt: Event) {
            const img = evt?.target as HTMLImageElement
            if (img && img.src && !img.src.endsWith("static/icon/user.svg")) {
                img.src = "static/icon/user.svg"
            }
        },

        getMenu(item: obj): obj[] {
            let arr: obj[] = [
                {
                    title: "数据",
                    sub: [
                        {
                            id: "CopyOrderNumber",
                            icon: "copy",
                            name: "复制订单号",
                        },
                        ...(item.address
                            ? [
                                {
                                    id: "CopyAddress",
                                    icon: "copy",
                                    name: "复制收货信息",
                                },
                            ]
                            : []),
                    ],
                },
                {
                    title: "操作",
                    prompt: "删除数据后将无法恢复，请谨慎操作！",
                    sub: [
                        {
                            id: "Delete",
                            icon: "delete",
                            name: "删除订单",
                        },
                    ],
                },
            ]

            if (this.menu_config && this.menu_config.length > 0) {
                arr.push({
                    title: "管理",
                    sub: this.menu_config,
                })
            }

            return arr
        },

        onSelectMenu(item: obj, evt: ElemEvent<string>) {
            switch (evt.value) {
                case "CopyOrderNumber":
                    Utils.copyText(item.orderNumber)
                    Message.success("复制成功")
                    break
                case "CopyAddress":
                    Utils.copyText([item.address.name, item.address.phone, `${[item.address.province, item.address.city, item.address.district, item.address.address].join('')}`].join(" "))
                    Message.success("复制成功")
                    break
                case "Delete":
                    this.onDeleteOrder(item)
                    break
                case "Href":
                    evt.data.href && this.jump(this.getUrl(item, evt.data.href))
                    break
                case "Model":
                    this.onOpenModel(evt.data, item)
            }
        },

        isTransportStatus(item: obj, status: string) {
            return item.paymentStatus === 1 && item.transportStatus === status
        },

        /**
         * 接单
         */
        onAccepted(item: obj) {
            Request.post("ADMIN://SubstanceOrder/Receiving", {
                uuid: item.uuid,
                entity: this.order_info_ac.id
            }).then(() => {
                Message.success("接单成功")

                switch (item.pathway) {
                    case 2: // 配送上门
                        item.transportStatus = "WAITING_DELIVERED"
                        break
                    case 3: // 自提
                        item.transportStatus = "PREPARING"
                        break
                    default:
                        item.transportStatus = "WAITING_SHIPMENTS"
                }
            })
        },

        /**
         * 备货完成
         */
        onPrepared(item: obj) {
            Request.post("ADMIN://SubstanceOrder/Prepared", {
                uuid: item.uuid,
                entity: this.order_info_ac.id
            }).then(() => {
                Message.success("备货完成")
                this.refresh()
            })
        },

        /**
         * 发货
         */
        onShipments(item: obj) {
            this.$refs.comp_form.display({
                title: "发货",
                method: "POST",
                submitApi: `ADMIN://SubstanceOrder/Delivery?uuid=${item.uuid}&entity=${this.order_info_ac.id}`,
                structure: [
                    {
                        type: "ORDINARY",
                        data: [
                            {
                                field: "expressNumber",
                                name: "expressNumber",
                                title: "快递单号",
                                length: 255,
                                required: true,
                                type: "Input",
                            },
                            {
                                field: "expressCompany",
                                name: "expressCompany",
                                title: "快递公司",
                                length: 255,
                                required: true,
                                type: "Select",
                                modify: true,
                                selectConfig: {
                                    field: null,
                                    controller: true,
                                    data: null,
                                    selectField: {},
                                    multiple: false,
                                    type: "com.jemmy.framework.component.order.substance.delivery.DeliveryCompany"
                                }
                            },
                        ],
                        title: "通用数据",
                        exist: true,
                    },
                ],
                data: item,
                onSubmit: () => {
                    item.transportStatus = "WAITING_RECEIPT"
                }
            })
        },

        /**
         * 开始配送
         */
        onStartDelivery(item: obj) {
            Request.post("ADMIN://SubstanceOrder/StartDelivery", {
                uuid: item.uuid,
                entity: this.order_info_ac.id
            }).then(() => {
                Message.success("提交成功")
                item.transportStatus = "DELIVERING"
            })
        },

        /**
         * 已送达
         */
        onDelivered(item: obj) {
            Request.post("ADMIN://SubstanceOrder/Delivered", {
                uuid: item.uuid,
                entity: this.order_info_ac.id
            }).then(() => {
                Message.success("提交成功")
                item.transportStatus = "DELIVERED"
            })
        },

        /**
         * 虚拟发货
         */
        onVirtualDelivery(item: obj) {
            this.$refs.comp_form.display({
                title: "发货",
                method: "POST",
                submitApi: `ADMIN://SubstanceOrder/VirtualDelivery?uuid=${item.uuid}&entity=${this.order_info_ac.id}`,
                structure: [
                    {
                        type: "ORDINARY",
                        data: [
                            {
                                field: "deliveryInfo",
                                name: "deliveryInfo",
                                title: "发货信息",
                                length: 1000,
                                required: false,
                                type: "Textarea",
                            },
                        ],
                        title: "通用数据",
                        exist: true,
                    },
                ],
                data: item,
                onSubmit: () => {
                    item.transportStatus = "WAITING_CONFIRM"
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>

</style>